import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

const IconZorroBankAccount = ({
  style,
  width = 20,
  height = 20,
}: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        width={width}
        height={height}
        viewBox="0 0 20 20"
      >
        <path
          d="M2.5 17.5H17.5M2.5 8.33333H17.5M4.16667 5L10 2.5L15.8333 5M3.33333 8.33333V17.5M16.6667 8.33333V17.5M6.66667 11.6667V14.1667M10 11.6667V14.1667M13.3333 11.6667V14.1667"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};

export { IconZorroBankAccount };
